/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/11/2021
 */

import {
	getFirestore,
	writeBatch,
	deleteField,
	arrayRemove,
	arrayUnion,
	increment,
	serverTimestamp,
	documentId,
	sum,
	average,
	count,
} from "firebase/firestore"

import DocRef from "@/core/js/backend/FIrebaseWrappers/ref/DocRef";
import CollectionRef from "@/core/js/backend/FIrebaseWrappers/ref/CollectionRef";
import CollectionGroupRef from "@/core/js/backend/FIrebaseWrappers/ref/CollectionGroupRef";

export default class FirestoreWrapper {

	firestore

	constructor(firebaseWrapper) {
		this.firestore = getFirestore(firebaseWrapper.firebaseApp)
	}

	doc(path){
		return new DocRef(this.firestore, path)

	}
 	collection(path){
		return new CollectionRef(this.firestore, path)
	}

	collectionGroup(path){
		return new CollectionGroupRef(this.firestore, path)
	}

	batch(){
		return writeBatch(this.firestore)
	}

	FieldValue = {
		delete(){
			return deleteField()
		},

		arrayRemove(...elements){
			return arrayRemove(...elements)
		},

		arrayUnion(...elements){
			return arrayUnion(...elements)
		},

		increment(number){
			return increment(Number(number))
		},

		serverTimestamp(){
			return serverTimestamp()
		}
	}

	FieldPath = {
		documentId(){
			return documentId()
		}
	}

	AggregateField = {
		sum,
		average,
		count,
	}
}
